import { Toaster } from "sonner";

/**
 * Modern fintech-style toast. Compact, bottom-anchored, subtle.
 *
 * Design:
 *   - Position: bottom-left on desktop, bottom-center on mobile
 *   - Never top-of-screen (that pattern is dated)
 *   - Pill / compact card, max-w-sm, one line where possible
 *   - Small coloured dot / left border to indicate variant
 *   - White background with backdrop blur; not full-width flash
 *   - Auto-dismiss in 3 seconds
 *   - Smooth spring slide-in
 *
 * Critical success actions (top-up complete, task submitted, withdrawal) use
 * <SuccessModal /> instead of toasts, per fintech convention.
 */
const SHARED_CLASSNAMES = {
  toast:
    "!bg-white/95 !backdrop-blur-md !text-neutral-900 !border !border-neutral-200 !shadow-lg !rounded-full !px-4 !py-2 !max-w-sm !min-h-0",
  title: "!text-sm !font-medium !text-neutral-900",
  description: "!text-xs !text-neutral-500",
  success: "!border-l-2 !border-l-emerald-500",
  error: "!border-l-2 !border-l-red-500",
  info: "!border-l-2 !border-l-amber-600",
  warning: "!border-l-2 !border-l-amber-500",
  icon: "!hidden",
  closeButton:
    "!bg-transparent !border-0 !text-neutral-400 hover:!text-neutral-700",
};

const SHARED_OPTIONS = {
  duration: 3000,
  classNames: SHARED_CLASSNAMES,
  unstyled: false,
};

export default function AppToaster() {
  return (
    <>
      <Toaster
        position="bottom-left"
        richColors={false}
        closeButton
        toastOptions={SHARED_OPTIONS}
        className="hidden md:block"
      />
      <Toaster
        position="bottom-center"
        richColors={false}
        closeButton
        toastOptions={SHARED_OPTIONS}
        className="md:hidden"
      />
    </>
  );
}
